import React from 'react'

export default function ToolTip(props) {
  return (
    <div className='tooltip'>
      {props.children}
    </div>
  )
}
